import cleanse from '../config/util/cleanse';
import { mergedCopy } from '../common/utils/objects';

const mergeObjects = <T>(c: T[], removeEmpty?: boolean): T => {
  const cleansedArray = c.filter(t => !!t).map(d => cleanse(d, removeEmpty));
  return mergedCopy(...cleansedArray) as T;
};

export default mergeObjects;
